// extracted by mini-css-extract-plugin
export default {"wrap":"BlocksTable_wrap__yeY+w","title":"BlocksTable_title__zRkfX","categoryCell":"BlocksTable_categoryCell__GU758","dot":"BlocksTable_dot__RHFZs","sub":"BlocksTable_sub__hRPra"};